// Display-only base64url JWT payload decode. Never trust this for authorization --
// the server (blueprint_runtime's IAM middleware) is the actual enforcement point.

export interface DecodedIdClaims {
  sub: string;
  username: string;
  email?: string;
  name?: string;
  exp: number;
  [key: string]: unknown;
}

export function decodeJwtPayload<T = DecodedIdClaims>(token: string): T | null {
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}

export function isExpired(claims: { exp: number } | null): boolean {
  if (!claims) return true;
  return claims.exp * 1000 <= Date.now();
}
